/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";
interface Props extends Omit<React.SVGProps<SVGSVGElement>, "css"> {
  weight?: "thin" | "normal";
}
export const IconServices = React.forwardRef<SVGSVGElement, Props>(
  (
    { fill = "none", stroke = "currentColor", weight = "normal", ...props },
    ref,
  ) => (
    <svg
      viewBox="0 0 24 24"
      ref={ref}
      css={css`
        * {
          vector-effect: non-scaling-stroke;
        }
        overflow: visible;
        height: 24px;
      `}
      {...props}
    >
      <g
        fill={fill}
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={weight === "normal" ? 1.5 : 1}
      >
        <path d="M.75 15v5.25l5.25 3 3.75-2.143M6 23.25V18M18 12l-5.25 3L18 18l5.25-3L18 12z" />
        <path d="M12.75 15v5.25l5.25 3 5.25-3V15M18 18v5.25M12 .75l-5.25 3 5.25 3 5.25-3-5.25-3z" />
        <path d="M6.75 3.75V9L12 12l5.25-3V3.75M12 6.75V12M9.75 14.143L6 12 .75 15 6 18l3-1.714" />
      </g>
    </svg>
  ),
);
